<ng-template #addEditComponent>
  <div class="row">
    <div class="col-md-12">
      <label class="kcs-form-label">Titolo</label>
      <input class="kcs-inputtext kcs-component" [(ngModel)]="date.title" type="text" style="width: 100%;"/>
    </div>
    <div class="col-md-6" style="margin-top: 10px;">
      <label class="kcs-form-label"><b>{{slotText}}</b></label>
    </div>
    <div  class="col-md-6" style="margin-top: 10px;">
      <label class="kcs-form-label"><b>{{durationText}}</b></label>
    </div>
    @if (date.app_id > 0 && (my_user.usr_id == date.usr_id || (tipo_utenza))) {
      <div  class="col-md-6" style="margin-top: 10px;">
        <label class="kcs-form-label">Prenotato da: <b>{{date.usr_displayname}}</b></label>
      </div>
    }
    @if (date.app_id > 0 && (tipo_utenza)) {
      <div  class="col-md-6" style="margin-top: 10px;">
        <select class="kcs-inputtext kcs-component" label="Stato appuntamento" label-placement="stacked" interface="popover" [(ngModel)]="date.stato.id">
          <option [value]="-1"> -------------------- </option>
          @for (s of lstStati; track s) {
            <option [value]="$safeNavigationMigration(s?.id)">{{s?.nome}}</option>
          }
        </select>
      </div>
    }

  </div>
</ng-template>

<!--  <c-modal #verticallyCenteredModal alignment="center" id="verticallyCenteredModal" [visible]="visible" (visibleChange)="handleChangeActivity($event)">

<c-modal-body>
  <div>
    <label>Titolo</label>
    <input class="form-control" [(ngModel)]="date.title" type="text"/>
  </div>
  <div>
    <label class="form-control"><b>{{slotText}}</b></label>
  </div>
  <div>
    <label class="form-control"><b>{{durationText}}</b></label>
  </div>
  <div *ngIf="date.app_id > 0 && (my_user.usr_id == date.usr_id || (tipo_utenza == 'ADMIN'))">
    <label class="form-control">Prenotato da: <b>{{date.usr_displayname}}</b></label>
  </div>
  <div *ngIf="date.app_id > 0 && (tipo_utenza == 'ADMIN')">
    <select class="form-control" label="Stato appuntamento" label-placement="stacked" interface="popover" [(ngModel)]="date.stato.id">
      <option [value]="-1"> -------------------- </option>
      <option *ngFor="let s of lstStati" [value]="s?.id">{{s?.nome}}</option>
    </select>
  </div>
        <button *ngIf="!(
            date.app_id > 0 
            && my_user.usr_id != date.usr_id 
            && tipo_utenza != 'ADMIN'
            )"
    (click)="save()" type="button" cButton style="cursor: pointer;">Salva
  </button>
</c-modal-body>
</c-modal> -->